import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

import { useUser } from "@/api/hooks/useUser";
import { isMobileApp } from "@/utils/platform";

export const UserIdentifier = () => {
  const posthog = usePostHog();
  const user = useUser();

  useEffect(() => {
    if (!user || !posthog) {
      return;
    }

    posthog.identify(user.userId.toString(), {
      email: user.email,
      name: user.name,
    });

    posthog.capture("mobile_app", {
      mobile_app: isMobileApp(),
    });
  }, [posthog, user]);

  return null;
};
